<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editTitle="editTitle"
    :readTitle="readTitle"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :isTextButton="isTextButton"
    :textButton="textButton"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        v-if="!loading"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :readOnly="readOnly"
        :partialReadOnly="partialReadOnly"
        @installment-update="loadServerEntry(entry.id)"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      partialReadOnly: false
    };
  },
  props: {
    entry: Object,
    editTitle: {
      type: String,
      default: "Edição de Conta a Receber"
    },
    readTitle: {
      type: String,
      default: "Visualização de Conta a Receber"
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CASH_INFLOW_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.cashInflow;
          this.extraData = response.data;
          if (this.editableEntry.canBeDeleted === false) {
            this.partialReadOnly = true;
          } else {
            this.partialReadOnly = false;
          }
          // console.log("cashInflow edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(cashInflow) {
      // console.log("cashInflow", cashInflow, cashInflow.validations, this.deepFilterEntryWithAllowedFieldsForMutation(cashInflow, cashInflow.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_UNPAID_CASH_INFLOW_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(cashInflow, cashInflow.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateUnpaidCashInflow.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updatePaidServerEntry: function(cashInflow) {
      // console.log("cashInflow", cashInflow, cashInflow.validations, this.deepFilterEntryWithAllowedFieldsForMutation(cashInflow, cashInflow.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_PAID_CASH_INFLOW_MUTATION,
          variables: {
            input: {
              id: cashInflow.id,
              chartId: cashInflow.chartId,
              periodIds: cashInflow.periodIds,
              observation: cashInflow.observation
            }//this.deepFilterEntryWithAllowedFieldsForMutation(cashInflow, cashInflow.validations)
          }
        })
        .then(response => {
          var errors = response.data.updatePaidCashInflow.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        if (this.partialReadOnly) {
          this.updatePaidServerEntry(this.editableEntry);
        } else {
          this.updateServerEntry(this.editableEntry);
        }
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_CASH_INFLOW_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      cashInflow(id: $id) {
        id
        code
        billDate
        totalPrice
        observation
        periodIds
        chartId
        chart {
          id
          text
        }
        customerId
        customer {
          id
          name
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            totalPaidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
        canBeDeleted
        validations
      }
      allPeople {
        id
        name
      }
      allHarvests {
        id
        name
      }
      allPeriodsEnabledForCostApportionment(periodStatuses: [1], cashFlowId: $id) {
        id
        name
        additionalInfo
        secondAdditionalInfo
      }
    }
    globalContext {
      allPeriodStatuses
    }
  }
`; 

const UPDATE_UNPAID_CASH_INFLOW_MUTATION = gql `
  mutation($input: CashInflowUpdateInputObject!) {
    updateUnpaidCashInflow(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

const UPDATE_PAID_CASH_INFLOW_MUTATION = gql `
  mutation($input: UpdatePaidCashInflowInputObject!) {
    updatePaidCashInflow(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
